import React from 'react';
import Link from 'gatsby-link';

import './styles.scss';

import org from './organizacja.jpg';
import tech from './tech.jpg';
import sztuka from './sztuka-bg.jpg';

const offersList = [{
  label: 'Sztuka i rozrywka',
  to: '/sztuka-i-rozrywka',
  image: sztuka,
}, {
  label: 'Technika Estradowa',
  to: '/technika-estradowa',
  image: tech,
}, {
  label: 'Organizacja wydarzeń',
  to: '/organizacja-wydarzen',
  image: org,
}]

const SingleOffer = ({offer}) => {
  return (
    <div className="single-offer" style={{backgroundImage: `url(${offer.image})`}}>
      <p className="single-offer__label">{offer.label}</p>
    </div>
  )
}

const Offers = () => {
  return (
    <div className="offers-section">
      <ul className="offers-section__list">
        {offersList.map(offer => (
          <li className="offers-section__element" key={offer.label}>
            <Link className="offers-section__link" to={offer.to}>
              <SingleOffer offer={offer} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
};

export default Offers;



// WEBPACK FOOTER //
// ./src/components/OfferSection/Offers.js